import { Factory } from '../Factory';
import { Preferences } from '../../model/user/Preferences';

export class PreferenceService implements IService {
  private rootScope: IRootScope;
  private cookies: any;
  private cookieNameFilters: string = "iio_filters";
  private cookieNameSelectedCollections: string = "iio_selected_collections";
  private cookieNamePreferences = "iio_preferences";
  private currentFilter: any;
  private selectedCollections: any;
  private store: any;

  constructor(rootScope: IRootScope, cookies: any) {
    this.rootScope = rootScope;
    this.cookies = cookies;
    this.currentFilter = cookies.getObject(this.cookieNameFilters) || {};
    this.selectedCollections = cookies.getObject(this.cookieNameSelectedCollections) || {};
    this.store = cookies.getObject(this.cookieNamePreferences) || {};

    if (_.isEmpty(this.store)) {
      this.Set(Preferences.TAG_RELATED, false);
      this.Set(Preferences.TAG_REPORT_PROJECT, true);
      this.Set(Preferences.TAG_REPORT_SYSTEM, true);
      this.Set(Preferences.TAG_REPORT_DOMAIN, false);
      this.Set(Preferences.TAG_REPORT_BATCH, false);
      this.ResetGridPreferences();
    }
  }

  public get SelectedCollections() {
    return this.selectedCollections;
  }

  public set SelectedCollections(collections: any[]) {
    this.selectedCollections = {};
    angular.forEach(collections, collection => {
      this.selectedCollections[collection.id] = true;
    });
    console.log('Putting selected collections: ', this.selectedCollections);
    this.cookies.putObject(this.cookieNameSelectedCollections, this.selectedCollections, {expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1))});
  }

  public get CurrentFilter(): any {
    return this.currentFilter;
  }

  public set CurrentFilter(filter: any) {
    this.currentFilter = filter;
    this.cookies.putObject(this.cookieNameFilters, filter, {expires: new Date(2020, 1, 1)});
  }

  public static GetEventForPreference(key: any): string {
    return 'PreferenceService.Update.' + key;
  }

  public Set(key: any, value: any) {
    if (this.store[key] != value) {
      this.store[key] = value;
      this.cookies.putObject(this.cookieNamePreferences, this.store, {expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1))});
    }
  }

  public Get(key: any) {
    let value = this.store[key];

    if (value instanceof Array) {
      return _.map(value, _.clone);
    }

    return _.clone(value);
  }

  public IsCollectionSelected(collection: any): boolean {
    return _.has(this.selectedCollections, collection.id);
  }

  public ResetGridPreferences(resetColumns = true) {
    if (resetColumns) {
      this.Set(Preferences.GRID_COLUMNS, [
        {headerName: "Sort Key", field: "sortKey", colId: "sortKey", filter: false},
        {headerName: "IIO Identifier", field: "id", colId: "resourceId", filter: false},
        {headerName: "Title", field: "title", filter: false},
        {headerName: "Path", field: "path"},
        {headerName: "Folder", field: "folders"},
        {headerName: "Created Date", field: "createdDate", filter: false},
        {headerName: "Modified Date", field: "modifiedDate", filter: false},
        {headerName: "From", field: "emailFrom"},
        {headerName: "To", field: "emailTo"},
        {headerName: "CC", field: "emailCc"},
        {headerName: "BCC", field: "emailBcc"},
        {headerName: "Conversation Topic", field: "emailConversationTopic"},
        {headerName: "Name", field: "filename", colId: "fileName"},
        {headerName: "Creator", field: "creator"},
        {
          headerName: "Size (MB)",
          field: "bytes",
          colId: "fileSize",
          template: "{{ data.bytes || 0 | bytes }}",
          filter: false
        },
        {
          headerName: "Page Count",
          field: "numPdfPages",
          colId: "pageCount",
          template: "{{ data.numPdfPages | number }}",
          filter: false
        },
        {headerName: "File Extension", field: "extension", colId: "fileExtension"},
        {headerName: "File Category", field: "category", colId: "category"},
        {headerName: "Record Type", field: "type", colId: "type"},
        {headerName: "Is Top Parent", field: "isTopParent", colId: "isTopParentResource"},
        {headerName: "Is Container", field: "isContainer"},
        {headerName: "Is Source Storage", field: "isSourceStorage"},
        {headerName: "Has Notes", field: "hasNotes"},
        {headerName: "Has Privileged Notes", field: "hasPrivilegedNotes"},
        {headerName: "Mime Type", field: "mimeType"},
        {headerName: "MD5", field: "md5"},
        {headerName: "Beg Bates", field: "lastBegBates"},
        {headerName: "End Bates", field: "lastEndBates"},
        {headerName: "Beg Attach Bates", field: "lastBegAttachBates"},
        {headerName: "End Attach Bates", field: "lastEndAttachBates"}
      ]);
    }

    this.Set(Preferences.GRID_COLUMNS_SORT_MODEL, null);
    this.Set(Preferences.GRID_COLUMNS_FILTER_MODEL, null);
  }
}

frontendApp.factory("PreferenceService", ["$rootScope", "$cookies", Factory.Create(PreferenceService)]);

// Expose as window global so bare `PreferenceService` references resolve
(window as any).PreferenceService = PreferenceService;
